<template>
  <div id="app" class="list-unstyled">
    <b-navbar toggleable="sm" class="main-menu" type="dark" variant="primary">
      <b-navbar-brand>
        <img id="logo" src="@/assets/aroolla-logo-color.svg" alt="Aroolla" />
      </b-navbar-brand>
      <b-nav-item to="/" right>Home</b-nav-item>
      <b-nav-item to="/day" right>Game</b-nav-item>
      <b-nav-item-dropdown text="Dashboard" right>
        <b-dropdown-item to="/dashboard/players" class="sub-menu">Players</b-dropdown-item>
        <b-dropdown-item to="/dashboard/ranking" class="sub-menu">Ranking</b-dropdown-item>
        <b-dropdown-item to="/dashboard/results" class="sub-menu">Results</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar>
    <router-view />
  </div>
</template>

<script>
import { initialStore } from "@/main.js";

export default {
  name: "app",
  computed: {
    store() {
      return this.$root.$data.store;
    }
  },
  created() {
    if (!("currentDay" in this.store)) this.initStore();
  },
  methods: {
    initStore(nboTeams, nboDays) {
      //Initialize days array in shared data store
      if (nboTeams === undefined) nboTeams = this.store.nboTeams;
      if (nboDays === undefined) nboDays = this.store.nboDays;

      let days = this.store.days;
      days.splice(0, days.length);
      for (let d = 0; d < nboDays; d++) {
        let day = {
          // supplierPrice in range CHF [1,3] per empty pod
          supplierPrice: 1 + Math.floor(Math.random() * 3),
          // customerPrice: even values in range CHF [16,30] per 4 pods lot
          customerPrice: 16 + 2 * Math.floor(Math.random() * 8),
          sales: [],
          purchase: []
        };
        for (var t = 0; t < nboTeams; t++) {
          day.sales.push({ qty: 0, paid: false });
          day.purchase.push({ qty: 0, paid: false });
        }
        days.push(day);
        this.store.currentDay = initialStore.currentDay;
        this.store.dayStage = initialStore.dayStage;
      }
      this.$root.save();
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Barlow:400,700&display=swap");
$body-color: #5185B4;
$primary: #564138;
$secondary: #5185B4;
$warning: #F7941D;
$danger: #EC008C;
// #251101

// Import Bootstrap and BootstrapVue source SCSS files
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";

#logo {
  height: 28px;
}
#app {
  font-family: "Barlow", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.main-menu {
    color: white;
}
.main-menu a {
    color:white;
}
.sub-menu a {
    color: black;
}
h1 {
  font-size: 80px;
  font-weight: bolder;
}
h2 {
  font-size: 40px;
  font-weight: bolder;
}
</style>
